module.exports = __webpack_public_path__ + "img/lc_bg.4f025228.png";